export default {
    education: {
        common: {
            approveState: {
                '1': 'Need approval',
                '2': 'In approval process',
                '3': 'Approved',
                '4': 'Canceled',
                '5': 'Doesn\'t need approval'
            },
            substate: 'Substate'
        },
        actionVacancy: {
            headers: {
                type: 'Type',
                state: 'State',
                responsible: 'Responsible',
            },
            types: {
                request: 'Request',
                active: 'Published',
                archive: 'Archive',
            },
            title: 'Объявление',
            card: {
                annotation: 'Annotation',
                authors: 'Authors',
                duration: 'Duration',
                exam: 'Exam type',
                requirments: 'Participant requirments',
                cost: 'Cost',
                costPerPeople: 'Cost per person',
                comment: 'Author comment',
                goals: 'Goals',
                tasks: 'Tasks',
                additionalResources: 'Additional resources',
                schedule: 'Estimated schedule',
                trainer: 'Estimated trainers',
                date: 'Date',

                publication: 'Publication date',
                done: 'Done date',
                libraryObjects: 'Library objects'
            },
            state: {
                planning: 'Event planning (Learning)',
                gathering: ' Gathering score',
                event: 'Application for event (Learning)',
                registration: 'Application for event',
                '7': 'Application for event (Scoring)',
                '8': 'Event planning (Scoring)',
            },
        },
        application: {
            create: 'Create application',
            edit: 'Edit application',
            send: 'Send',
            title: 'Application',
            headers: {
                vacancy: 'Action',
                sender: 'Sender',
                datetime: 'Time',
            },
        },
        action: {
            headers: {
                project: 'Action',
                stage: 'Stage',
            },
            participants: 'Participants',
            stages: 'Scenario',
        },
        approvalApplication: {
            headers: {
                people: 'Person',
                vacancy: 'Course name',
            }
        },
        event: {
            name: 'Name',
            toPersonTimetable: 'To person timetable'
        },
        courses: {
            headers: {
                name: 'Course name',
                isIndividual: 'Individual course',
                needApproval: 'Need approval'
            },
            annotation: 'Annotation',
            createData: 'Creation date',
            authors: 'Authors',
            duration: 'Anticipated duration',
            examType: 'Exam type',
            requirments: 'Requirements for participant',
            cost: 'General cost',
            costPerPerson: 'Cost per person',
            comment: 'Author comment',
            goals: 'Goals',
            tasks: 'Tasks',
            resources: 'Additional resources',
            schedule: 'Anticipated schedule',
            trainer: 'Anticipated trainers',
            valuta: 'Currency',
            stageList: 'Stages',
            scenName: 'Scenario name',
            type: 'Type',
            typeNumber: {
                1: 'Remote education',
                4: 'Remote evaluation'
            },
            enroll: 'Enroll',
            enrollSuccess: 'Enroll success'
        },
        scenario: {
            name: '%(name)s',
            object: 'Scenario topic',
            responsible: 'Responsible',
            person: 'Person',
            sender: 'Sender',
            send: 'Sent',
            scen: 'Scenario name',
            stageName: 'Stage name',
            tests: 'Tests',
            stages: 'Stages',
            states: 'State',
            test: 'Test',
            scormTest: 'SCORM - Test',
            type: 'Type',
            book: 'Book',
            doc: 'Document',
            training: 'Education',
            toScenario: 'To scenario',
            forNextStage: 'For the next stage you have to close all tests and mark all books as read',
            state: {
                '3': 'Opened',
                '7': 'Done',
                '8': 'Canceled',
                '0': 'Not available',
                '1': 'On approval',
            },
            markAsRead: 'Mark as read'
        },
        trainer: {
            responsible: 'Responsible',
            course: 'Course',
            participantsNumber: 'Participants number',
            participants: 'Participants',
            missed: 'Missed',
            presence: 'Presence',
            mark: 'Mark'
        },
        news: {
            name: 'Name',
            date: 'Date',
            state: 'State',
            briefNews: 'Brief news'
        },
        fileLibrary: {
            name: 'Name',
            sentDate: 'Sent date'
        }
    }
};
